module.exports = __webpack_public_path__ + "img/x12.107be94f.jpg";